<template>
  <div>
    <h1 class="text-center">Parametry główne</h1>
    <table class="table table-striped ">
      <thead>
        <tr class="tr-table">
          <th scope="col">ID</th>
          <th scope="col">Nazwa</th>
          <th scope="col">Wartość</th>
          <th scope="col">Edytuj wartość</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="parameter in parameters.data" :key="parameter.id">
          <td>{{ parameter.id }}</td>
          <td>{{ parameter.variable }}</td>
          <td>{{ parameter.value }}</td>
          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#exampleModal"
              v-on:click="setParameterToEdit(parameter)"
            >
              Edytuj
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Edytuj parametr {{ this.variable }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit="updateParameter($event)">
              <div class="input-container">
                <label>Wartość: </label>
                <input
                  v-model="value"
                  id="name"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                />
              </div>
              <button class="buttonm btn btn-outline-dark" type="submit">
                Zapisz
              </button>
              <div v-if="parameterUpdatedMessage">
                <p>{{ parameterUpdatedMessage }}</p>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <h1 class="text-center">Mnożniki ceny według czasu</h1>
    <table class="table table-striped ">
      <thead>
        <tr class="tr-table">
          <th scope="col">ID</th>
          <th scope="col">Nazwa</th>
          <th scope="col">Wartość</th>
          <th scope="col">Edytuj wartość</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="parameter in priceConverters" :key="parameter.id">
          <td>{{ parameter.id }}</td>
          <td>{{ parameter.name }}</td>
          <td>{{ parameter.number }}</td>
          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#editPriceConventer"
              v-on:click="setPriceConventerToEdit(parameter)"
            >
              Edytuj
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="modal fade"
      id="editPriceConventer"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editPriceConventer"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editPriceConventer">
              Edytuj mnożnik ceny {{ this.priceConverterVariable }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              class="topform"
              @submit.prevent="updatePriceConventer($event)"
            >
              <div class="input-container">
                <label>Wartość: </label>
                <input
                  v-model="priceConverterValue"
                  id="name"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                />
              </div>
              <button class="buttonm btn btn-outline-dark" type="submit">
                Zapisz
              </button>
              <div v-if="parameterUpdatedMessage">
                <p>{{ parameterUpdatedMessage }}</p>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../axios";
export default {
  name: "parameters",
  computed: {
    parameters() {
      return this.$store.getters.getParameters;
    },
    parameterUpdatedMessage() {
      return this.$store.getters.getParameterUpdatedMessage;
    },
    priceConverters() {
      return this.$store.getters.getPriceConventers;
    },
  },
  created() {
    this.$store.dispatch("getAllParameters");
    this.$store.dispatch("getAllPriceConverters");
  },
  data: function() {
    return {
      variable: "",
      value: "",
      priceConverterValue: "",
      priceConverterVariable: "",
      priceConverterId: "",
    };
  },
  methods: {
    updateParameter(e) {
      e.preventDefault();
      let body = {
        variable: this.variable,
        value: this.value,
      };
      this.$store.dispatch("updateParameter", body);
    },
    updatePriceConventer() {
      let body = {
        name: this.priceConverterVariable,
        number: this.priceConverterValue,
      };
      axios
        .put(`/api/priceConverter/${this.priceConverterId}`, body)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie zmieniono wartość",
            });
            this.$store.dispatch("getAllPriceConverters");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "error",
            text: "Nie udało się zmienić wartości dla tego parametru",
          });
        });
    },
    setParameterToEdit(item) {
      this.variable = item.variable;
      this.value = item.value;
    },
    setPriceConventerToEdit(item) {
      this.priceConverterVariable = item.name;
      this.priceConverterValue = item.number;
      this.priceConverterId = item.id;
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
button.btn {
  margin-left: 20px;
}
.input-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.input-container label {
  margin: 0px 5px 0px 0px;
}
</style>
